import { render, staticRenderFns } from "./RelatorioAdesao.vue?vue&type=template&id=45f84b47&scoped=true"
import script from "./RelatorioAdesao.vue?vue&type=script&lang=ts"
export * from "./RelatorioAdesao.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioAdesao.vue?vue&type=style&index=0&id=45f84b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f84b47",
  null
  
)

export default component.exports